/*
  Desktop menu dropdowns: keep an opened flyout (a make's models under Shop by Vehicle) inside
  the window. The theme anchors each flyout to its menu item, so items low in a long list
  opened lists that ran off the bottom of the screen. The flyout is moved up as far as the
  header allows, and scrolls inside itself only if it is still taller than the space left.
*/
(function () {
  var MARGIN = 16;
  var TWO_COLUMNS_FROM = 13;

  // Long lists show in two columns (header-footer.css); fill them top to bottom.
  document.querySelectorAll('.header .dropdown__nav').forEach(function (list) {
    var count = list.children.length;
    if (count >= TWO_COLUMNS_FROM) list.style.setProperty('--menu-rows', Math.ceil(count / 2));
  });

  function fit(details) {
    var flyout = details.lastElementChild;
    if (!flyout || !flyout.classList.contains('dropdown')) return;
    var list = flyout.firstElementChild;

    flyout.style.removeProperty('top');
    if (list) {
      list.style.removeProperty('max-height');
      list.style.removeProperty('overflow-y');
    }

    var header = document.querySelector('.header-section');
    var ceiling = header ? header.getBoundingClientRect().bottom : 0;
    var floor = window.innerHeight - MARGIN;
    var rect = flyout.getBoundingClientRect();

    var shift = Math.min(Math.max(0, rect.bottom - floor), Math.max(0, rect.top - ceiling));
    if (shift) flyout.style.top = -shift + 'px';

    var room = floor - ceiling;
    if (list && rect.height > room) {
      list.style.maxHeight = room + 'px';
      list.style.overflowY = 'auto';
    }
  }

  // <details> toggle events don't bubble, so listen while they travel down.
  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details.matches || !details.matches('.header details[level="child"]') || !details.open) return;
      window.requestAnimationFrame(function () {
        fit(details);
      });
    },
    true
  );
})();
